module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration007.aee10e9d.webp";